import { render } from "./Capacity.vue?vue&type=template&id=867c6786"
import script from "./Capacity.vue?vue&type=script&lang=js"
export * from "./Capacity.vue?vue&type=script&lang=js"

import exportComponent from "d:\\Beks\\EasyTicket\\easyticket.webshop.admin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__